export default function () {
    var quantity = document.getElementById('quantity');
    if (quantity) {
        document.querySelector('.qty__minus').onclick = function () {
            var step= this.dataset.step? this.dataset.step: "4";
            step= parseInt(step);
            if(parseInt(quantity.value) > step){
                quantity.value=parseInt(quantity.value)-step;
            }
        };
        if(quantity.getAttribute("min")!="1"){
            
            quantity.onblur = function () {
                var step= parseInt(quantity.getAttribute("min"));
                var qty=parseInt(quantity.value)-parseInt(quantity.value)%step;
                if(qty < step){
                    qty=step;
                }
                quantity.value=qty;
            }
        };
        document.querySelector('.qty__plus').onclick = function () {
            var step= this.dataset.step? this.dataset.step: "4";
            step= parseInt(step);
            quantity.value=parseInt(quantity.value)+step;
            
        };
    }
};